module.exports = __webpack_public_path__ + "static/concept2-pc-6fee00040124e882690c8ee432f0fb63.svg";